import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-toast-wrapper"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_toast = _resolveComponent("base-toast")

  return ($data.notifications.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_TransitionGroup, {
          tag: "div",
          class: "gfu-toast-wrapper__list",
          name: "gfu-notification-slide-and-fade"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.notificationsSorted, (notification) => {
              return (_openBlock(), _createBlock(_component_base_toast, _mergeProps({
                key: notification.id
              }, { ref_for: true }, notification, {
                onClose: $event => ($options.notificator.hide(notification))
              }), null, 16 /* FULL_PROPS */, ["onClose"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })
      ]))
    : _createCommentVNode("v-if", true)
}